
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/meta-offline",
      function () {
        return require("private-next-pages/destinations/meta-offline.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/meta-offline"])
      });
    }
  